( () => {
    const config = window.snCookieConsent || {};
    const cookieName = config.cookieName || 'sn_cookie_consent';
    const cookieLifetime = parseInt( config.cookieLifetime || 365, 10 );
    const version = parseInt( config.version || 1, 10 );
    const ga4Property = config.ga4Property || '';

    let analyticsLoaded = false;

    const getCookie = ( name ) => {
        const cookies = document.cookie ? document.cookie.split( '; ' ) : [];
        const cookie = cookies.find( ( item ) => item.startsWith( `${ encodeURIComponent( name ) }=` ) );

        if ( ! cookie )
            return null;

        return decodeURIComponent( cookie.split( '=' ).slice( 1 ).join( '=' ) );
    };

    const setCookie = ( name, value, days ) => {
        const expires = new Date();

        expires.setTime( expires.getTime() + days * 24 * 60 * 60 * 1000 );
        document.cookie = `${ encodeURIComponent( name ) }=${ encodeURIComponent( value ) };expires=${ expires.toUTCString() };path=/;SameSite=Lax`;
    };

    const parseConsent = () => {
        const raw = getCookie( cookieName );

        if ( ! raw )
            return null;

        try {
            const consent = JSON.parse( raw );

            if ( parseInt( consent.version || 0, 10 ) !== version )
                return null;

            return {
                version,
                bing: true,
                analytics: consent.analytics === true
            };
        } catch ( error ) {
            return null;
        }
    };

    const saveConsent = ( settings ) => {
        const consent = {
            version,
            bing: true,
            analytics: settings.analytics === true
        };

        setCookie( cookieName, JSON.stringify( consent ), cookieLifetime );
        activateConsent( consent );
        return consent;
    };

    const loadScript = ( src ) => new Promise( ( resolve, reject ) => {
        const existing = document.querySelector( `script[src="${ src }"]` );

        if ( existing ) {
            resolve( existing );
            return;
        }

        const script = document.createElement( 'script' );
        script.src = src;
        script.async = true;
        script.onload = () => resolve( script );
        script.onerror = reject;
        document.head.appendChild( script );
    } );

    const activateBing = () => {
        document.querySelectorAll( 'iframe.map[data-src], iframe[data-consent-service="bing"][data-src]' ).forEach( ( iframe ) => {
            if ( ! iframe.getAttribute( 'src' ) )
                iframe.setAttribute( 'src', iframe.dataset.src );
        } );
    };

    const activateAnalytics = () => {
        if ( analyticsLoaded || ! ga4Property )
            return;

        analyticsLoaded = true;
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () {
            window.dataLayer.push( arguments );
        };

        loadScript( `https://www.googletagmanager.com/gtag/js?id=${ encodeURIComponent( ga4Property ) }` ).then( () => {
            window.gtag( 'js', new Date() );
            window.gtag( 'config', ga4Property, {
                anonymize_ip: true
            } );
        } );
    };

    const dispatchConsent = ( consent ) => {
        document.dispatchEvent( new CustomEvent( 'sn:consent', {
            detail: consent
        } ) );
    };

    const activateConsent = ( consent ) => {
        activateBing();

        if ( consent.analytics )
            activateAnalytics();

        dispatchConsent( consent );
    };

    const showModal = ( modal ) => {
        modal.classList.add( 'is-active' );
        modal.setAttribute( 'aria-hidden', 'false' );
    };

    const hideModal = ( modal ) => {
        modal.classList.remove( 'is-active' );
        modal.setAttribute( 'aria-hidden', 'true' );
    };

    const syncModal = ( modal, consent ) => {
        const analyticsInput = modal.querySelector( '[data-consent-analytics]' );

        if ( analyticsInput )
            analyticsInput.checked = consent?.analytics === true;
    };

    const bindLanguageSelect = ( modal ) => {
        const languageSelect = modal.querySelector( '[data-consent-language]' );

        if ( ! languageSelect )
            return;

        languageSelect.addEventListener( 'change', ( event ) => {
            const url = event.target.value;

            if ( url && url !== window.location.href )
                window.location.href = url;
        } );
    };

    const initModal = () => {
        const modal = document.getElementById( 'sn-cookie-consent' );

        if ( ! modal )
            return;

        const consent = parseConsent();
        const analyticsInput = modal.querySelector( '[data-consent-analytics]' );
        const settings = modal.querySelector( '[data-consent-settings]' );
        const showSettings = modal.querySelector( '[data-consent-show-settings]' );
        const saveWrapper = modal.querySelector( '[data-consent-save-wrapper]' );
        const acceptWrapper = modal.querySelector( '[data-consent-accept-wrapper]' );

        if ( consent ) {
            activateConsent( consent );
        } else {
            showModal( modal );
        }

        syncModal( modal, consent );
        bindLanguageSelect( modal );

        modal.addEventListener( 'click', ( event ) => {
            if ( event.target.closest( '[data-consent-accept]' ) ) {
                event.preventDefault();
                hideModal( modal );
                saveConsent( {
                    analytics: true
                } );
            }

            if ( event.target.closest( '[data-consent-save]' ) ) {
                event.preventDefault();
                hideModal( modal );
                saveConsent( {
                    analytics: analyticsInput?.checked === true
                } );
            }
        } );

        showSettings?.addEventListener( 'click', ( event ) => {
            event.preventDefault();
            settings.hidden = false;
            saveWrapper?.removeAttribute( 'hidden' );
            acceptWrapper?.setAttribute( 'hidden', '' );
            showSettings.remove();
            analyticsInput?.focus();
        } );

        document.addEventListener( 'keydown', ( event ) => {
            if ( event.key === 'Escape' && modal.classList.contains( 'is-active' ) && settings.hidden )
                showSettings?.click();
        } );

        document.addEventListener( 'click', ( event ) => {
            const trigger = event.target.closest( '[data-consent-open]' );

            if ( ! trigger )
                return;

            event.preventDefault();
            syncModal( modal, parseConsent() );
            settings.hidden = false;
            saveWrapper?.removeAttribute( 'hidden' );
            acceptWrapper?.setAttribute( 'hidden', '' );
            showSettings?.remove();
            showModal( modal );
            analyticsInput?.focus();
        } );
    };

    window.snConsent = {
        get: parseConsent,
        save: saveConsent
    };

    window.snTrackEvent = ( name, params = {} ) => {
        const consent = parseConsent();

        if ( ! consent || ! consent.analytics || typeof window.gtag !== 'function' )
            return;

        window.gtag( 'event', name, params );
    };

    document.addEventListener( 'DOMContentLoaded', initModal );
} )();
